import { Auth } from "aws-amplify"

import * as Sentry from "@sentry/react"

import Grid from "@material-ui/core/Grid"

import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs"
import { Form, Field, FormElement } from "@progress/kendo-react-form"
import { Input } from "@progress/kendo-react-inputs"
import { Button } from "@progress/kendo-react-buttons"

function NewCognitoPasswordPrompt(props) {
  const { close, cognitoUser, notificationCreate, success, backgroundProcessor } =
    props

  const NewPasswordForm = (formRenderProps) => (
    <Grid container direction="column" item>
      <Grid item>
        <FormElement>
          <Grid container direction="column">
            <Grid item>
              <Dialog title="New password required" onClose={close}>
                <Grid
                  container
                  direction="column"
                  style={{ maxWidth: "640px", maxHeight: "640px" }}
                >
                  <Grid item style={{ paddingBottom: "2rem" }}>
                    <p>
                      To access your account, you need to set up a new password.
                      Requirements:
                    </p>
                  </Grid>

                  <Grid item style={{ paddingBottom: "2rem" }}>
                    <p>{"- Requires a minimum length of 8 characters"}</p>
                    <p>{"- Requires at least one number"}</p>
                    <p>
                      {"- Requires at least one special character from the set " +
                        "= + - ^ $ * . [ ] { } ( ) ? \" ! @ # % & / \\ , > < ' : ; | _ ~ `"}
                    </p>
                    <p>{"- Requires at least one uppercase letter"}</p>
                    <p>{"- Requires at least one lowercase letter"}</p>
                  </Grid>

                  <Grid item style={{ paddingBottom: "1rem" }}>
                    <Field
                      id="firstName"
                      name="firstName"
                      label="First Name"
                      component={Input}
                    />
                    </Grid>
                    <Grid item style={{ paddingBottom: "1rem" }}>
                    <Field
                      id="lastName"
                      name="lastName"
                      label="Last Name"
                      component={Input}
                    />
                    </Grid>
                    <Grid item style={{ paddingBottom: "1rem" }}>
                    <Field
                      id="newPassword"
                      name="newPassword"
                      label="New Password"
                      type="password"
                      component={Input}
                      validator={(value) => {
                        return new RegExp(
                          // eslint-disable-next-line max-len
                          /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[=+\-^$*.[\]{}()?"!@#%&/\\,><':;|_~`])\S{8,99}$/
                        ).test(value)
                          ? ""
                          : "New password is invalid."
                      }}
                    />
                  </Grid>
                </Grid>

                <DialogActionsBar>
                  <Button
                    style={{ color: "white" }}
                    look={"flat"}
                    themeColor={"primary"}
                    onClick={close}
                  >
                    Cancel
                  </Button>

                  <Button
                    style={{ color: "white" }}
                    look={"flat"}
                    themeColor={"primary"}
                    onClick={formRenderProps.onSubmit}
                  >
                    Set
                  </Button>
                </DialogActionsBar>
              </Dialog>
            </Grid>
          </Grid>
        </FormElement>
      </Grid>
    </Grid>
  )

  const formOnSubmitHandler = async (form) => {
    const { newPassword, firstName, lastName } = form

    console.log(form)

    if (!firstName || !lastName || !newPassword || typeof newPassword !== "string") return

    try {
      backgroundProcessor?.add()

      await Auth.completeNewPassword(cognitoUser, newPassword, { given_name: firstName, family_name: lastName })

      success({ 
        username: cognitoUser.username,
        newPassword: newPassword
      })

      backgroundProcessor?.remove()
    } catch (error) {
      backgroundProcessor?.remove()

      Sentry.captureException(error, {
        tags: { context: "amplify", noFallback: true },
      })

      notificationCreate({
        severity: "error",
        message:
          "Apologies, we could not set your new password. " +
          "Our team has been notified about the issue. " +
          "Please, wait a moment and try again.",
      })
    }

    close()
  }

  return (
    <Form
      initialValues={{
        newPassword: "",
      }}
      onSubmit={formOnSubmitHandler}
      render={NewPasswordForm}
    />
  )
}

export default NewCognitoPasswordPrompt
